module.exports = __webpack_public_path__ + "img/reseau-eiffel.8fa781a9.png";